import React, { createContext, useContext } from "react";
import { HappyHourMessagesByLocation } from "./types/HappyHour.interface";

export interface HappyHourContextValue {
  data?: HappyHourMessagesByLocation;
  loading?: boolean;
  refresh: () => void;
  topBannerClosed?: boolean;
  setTopBannerClosed?: React.Dispatch<React.SetStateAction<boolean>>;
}

const HappyHourContext = createContext<HappyHourContextValue>({
  refresh: () => {},
});

export const useHappyHourContext = () => {
  return useContext(HappyHourContext);
};

export default HappyHourContext;
